import React from 'react';
import Table from '../Table';

const title = "Other Details";
const columns = [
	{
		name: '',
		selector: 'rowName',
		sortable: false,
	},
	{
		name: 'Minimum Transactions',
		selector: 'minTxns',
		sortable: false
	},
	{
		name: 'Match Confidence',
		selector: 'matchConfidence',
		sortable: false
	},
	{
		name: 'Maximum Missed Transactions',
		selector: 'maxMissedTxns',
		sortable: false
	},
	{
		name: 'Schedule Tolerance Days',
		selector: 'scheduleToleranceDays',
		sortable: false
	}
];

function ThresholdTable(props) {
	return (
		<Table className="thresholdTable" title={title} columns={columns} data={props.data} pagination={false} />
	);
}

export default ThresholdTable;